import style from "./style.module.scss";
import icon from "../../../img/modals/like.svg";
import {useStore} from "effector-react";
import {$store} from "../../../store";

const AllSuccess = (props:{onOk:Function}) => {

	const store = useStore($store);

	return (
		<div className={style.allSuccess}>
			<div className={style.icon}>
				<img src={icon} alt=""/>
			</div>
			<p className={style.title}>Поздравляем! Вы выполнили все условия акции!</p>
			<p className={style.subtitle}>Если ваш прогноз будет верным, вы получите 5 000 гурдов на бонусный баланс!</p>
			<p className={style.subtitleB}>Желаем Вам удачи!</p>
			<div className={style.buttons}>
				<div onClick={()=>{ props.onOk(); }} className={`${style.btn} ${style.btnA}`}>Понятно</div>
			</div>
		</div>
	);
};

export default AllSuccess;
